import { logoutAndRedirect } from './sessionReset';

export function checkAuthAndRedirect(navigate) {
  const userId = sessionStorage.getItem('user_id') || sessionStorage.getItem('player_id');
  if (!userId) {
    // Check if redirect_path is already set
    if (!sessionStorage.getItem('redirect_path')) {
      const currentPath = window.location.pathname + window.location.search;
      console.log('Current Path:', currentPath);
      sessionStorage.setItem('redirect_path', currentPath);
    }
    navigate('/');
  }
}

export function logout() {
  logoutAndRedirect();
}

export const isAdmin = () => sessionStorage.getItem('is_admin') === 'true';
